/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

(function() {
  if (typeof subscribe !== 'function' || typeof theme === 'undefined') return;
  subscribe(theme.PUB_SUB_EVENTS.variantChange, function(event) {
    var sectionId = event.data.sectionId;
    var html = event.data.html;
    ['CustomDimensions', 'CustomSku'].forEach(function(prefix) {
      var freshEl = html.getElementById(prefix + '-' + sectionId);
      var currentEl = document.getElementById(prefix + '-' + sectionId);
      if (freshEl && currentEl) {
        currentEl.innerHTML = freshEl.innerHTML;
        currentEl.style.display = freshEl.style.display === 'none' ? 'none' : '';
      }
    });
  });
})();
  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
